var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\" id=\"modal-title\">\nAdd Alias to <span style=\"color:rebeccapurple;font-weight:400\">{{indexName}}</span> Index\n</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div>\n<form name=\"ciForm\">\n<div class=\"form-group\">\n<label>Name</label>\n<input type=\"text\" ng-model=\"formData.name\" class=\"form-control\" required>\n</div>\n</form>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" ng-disabled=\"!ciForm.$valid\" type=\"button\" ng-click=\"save()\">Save</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button>\n</div>";
var id1="components/index-aliases-tab-content/create-alias-modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-aliases-tab-content/create-alias-modal.html
// module id = 909
// module chunks = 0